import { render, staticRenderFns } from "./SelectAppointmentStep.vue?vue&type=template&id=4285748c"
import script from "./SelectAppointmentStep.vue?vue&type=script&lang=ts"
export * from "./SelectAppointmentStep.vue?vue&type=script&lang=ts"
import style0 from "./SelectAppointmentStep.vue?vue&type=style&index=0&id=4285748c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports